import { CONFIG } from '../config';

/** Localized public home `/{lang}` for SPA routes (cookie / browser / default). */
export function spaLocaleHomePath() {
  const lang = CONFIG.getLocaleFromClient();
  return `/${lang}`;
}
